export enum ProfileTabEnum {
    MyOrder = "MyOrder",
    MyAccount = "MyAccount",
    PaymentHistory = "PaymentHistory",
    Faqs = "Faqs",
    Terms = "Terms",
    ManageAddress = "ManageAddress",
    FamilyMember = "FamilyMember",
    EditProfile = "EditProfile",
    DownloadReport  ="DownloadReport",
    ActivityLogs  ="ActivityLogs"
}